import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	disclaimerMessage: {
		id: 'company-hub.cards-extension.ai-disclaimer.disclaimer-message',
		defaultMessage: 'AI generated content',
		description: 'AI disclaimer used in the cards footer to inform users that AI is being used.',
	},
});
